export { useLoyaltyContent } from './useLoyaltyContent';
